export const COLUMNS = [
  {
    title: "Batch",
    dataIndex: "batch",
    key: "batch",
    sortable: true,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sortable: true,
  },
  {
    title: "Cost Price",
    dataIndex: "costPrice",
    key: "costPrice",
    sortable: true,
  },
  {
    title: "MRP",
    dataIndex: "mrp",
    key: "mrp",
    sortable: true,
  },
  {
    title: "Expiry Date",
    dataIndex: "expiryDate",
    key: "expiryDate",
    sortable: true,
  },
  {
    title: "MFG",
    dataIndex: "manufacturer",
    key: "manufacturer",
    sortable: true,
  },
];
